import React from "react";
import { useParams } from "react-router-dom";
import ProductGrid from "./home/ProductGrid";
import SEO from "./SEO";

const ShopAll = () => {
  const { categoryId, categoryName } = useParams(); // 👈 Get category name + id

  return (
    <div>
            <SEO
                    title='Patch Designers For Hats shop All Product'
                    description='Patch Designers For Hats'
                    keywords='Patch Designers For Hats'
                  />
<ProductGrid categoryId="allproducts" categoryName="All Products" />      
    </div>
  );
};

export default ShopAll;
